import { useEffect, useRef } from "react";
import { Bot, Loader2 } from "lucide-react";
import { MessageBubble } from "@/components/assistant/MessageBubble";
import { Composer } from "@/components/assistant/Composer";

const SUGGESTIONS = ["sors 2 kits 001", "entre 50 pièces 006", "combien de 006 ?", "quelles pièces manquent ?", "combien de kits 001 je peux faire ?", "que manque-t-il pour faire 10 kits 002 ?"];

export function AssistantChat({ chat }) {
  const end = useRef(null);
  const messages = chat.conv?.messages || [];
  useEffect(() => { end.current?.scrollIntoView({ behavior: "smooth", block: "end" }); }, [messages.length, chat.sending, chat.version]);

  return (
    <div className="flex h-full min-h-0 flex-col" data-testid="assistant-chat">
      <div className="flex-1 space-y-4 overflow-y-auto bg-slate-50 p-4">
        {chat.loading && <div className="text-sm text-slate-500">Chargement…</div>}
        {!chat.loading && messages.length === 0 && (
          <div className="py-6 text-center" data-testid="assistant-empty">
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-orange-500 text-slate-950"><Bot className="h-6 w-6" /></div>
            <p className="font-display text-2xl font-bold uppercase">Que voulez-vous faire ?</p>
            <p className="mb-4 text-sm text-slate-500">Écrivez ou dictez une instruction. Chaque action vous sera proposée avant validation.</p>
            <div className="flex flex-wrap justify-center gap-2">
              {SUGGESTIONS.map((s, i) => (
                <button key={s} type="button" onClick={() => chat.send(s)} disabled={chat.sending} data-testid={`assistant-suggestion-${i}`}
                  className="rounded-full border bg-white px-3.5 py-2 text-sm text-slate-700 transition-colors hover:border-slate-400 hover:bg-slate-100">« {s} »</button>
              ))}
            </div>
          </div>
        )}
        {messages.map((m, i) => <MessageBubble key={m.id} m={m} idx={i} chat={chat} />)}
        {chat.sending && <div className="flex items-center gap-2 pl-10 text-sm text-slate-500" data-testid="assistant-thinking"><Loader2 className="h-4 w-4 animate-spin" /> L'assistant analyse votre demande…</div>}
        <div ref={end} />
      </div>
      <Composer chat={chat} />
    </div>
  );
}
